export default __webpack_public_path__ + "static/media/Glove1.6e75f7ec.svg";